import dayjs from 'dayjs';
import 'dayjs/locale/ja';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.locale('ja');

type InputType = string | Date | number;

function cdateJST(): dayjs.Dayjs;
function cdateJST(input: InputType | undefined): dayjs.Dayjs;
function cdateJST(input?: InputType): dayjs.Dayjs {
  if (input !== undefined && input !== null) {
    return dayjs(input).tz('Asia/Tokyo').locale('ja');
  }
  return dayjs().tz('Asia/Tokyo').locale('ja');
}

export { cdateJST };
